import { mapState, mapGetters, mapActions } from 'vuex'

export const chatComputed = {
  ...mapState('chat', {
    chatDialog: (state) => state.chatDialog,
    chatDetails: (state) => state.chatDetails,
    chatConnected: (state) => state.chatConnected,
    chatMessages: (state) => state.message,
    patientProviderDetails: (state) => state.patientProviderDetails,
    loading: (state) => state.loading,
    providerResponse: (state) => state.providerResponse,
  }),
  ...mapGetters('chat', [
    'getChatDialogStatus',
    'getChatDetails',
    'getMessage',
    'getProviderResponseStatus',
  ]),
}

export const chatMethods = mapActions('chat', [
  'setChatDialogStatus',
  'setChatDetails',
  'setChatMessage',
  'setConnectionStatus',
  'setLoadingStatus',
  'setInactiveStatus',
  'setProviderResponseStatus',
])
